__turbopack_context__.v({
  "chevron-wrapper": "styles-module__WuS7WW__chevron-wrapper",
  "footer-links": "styles-module__WuS7WW__footer-links",
  "footer-wrapper": "styles-module__WuS7WW__footer-wrapper",
  "li": "styles-module__WuS7WW__li",
  "page-content-wrapper": "styles-module__WuS7WW__page-content-wrapper",
  "styled-button": "styles-module__WuS7WW__styled-button",
  "terms-content": "styles-module__WuS7WW__terms-content",
  "ul": "styles-module__WuS7WW__ul",
});
